import React from 'react';
import AnimatedButton from './AnimatedButton';
import Reveal from './Reveal';

const differentials = [
  {
    title: "Economia Real",
    desc: "Redução de até 84% na conta de luz desde o primeiro mês de operação."
  },
  {
    title: "Atendimento Rápido",
    desc: "Suporte técnico local e ágil para garantir que sua usina nunca pare."
  },
  {
    title: "Escalabilidade",
    desc: "Projetos modulares que podem crescer junto com a sua demanda energética."
  },
  {
    title: "Tecnologia",
    desc: "Utilizamos as marcas líderes mundiais em painéis e inversores (Tier 1)."
  }
];

const Differentials: React.FC = () => {
  const waLink = "https://wa.me/5573998595834?text=Olá,%20gostaria%20de%20mais%20informações";

  return (
    <section id="diferenciais" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-12">
            <div>
              <Reveal>
                <h2 className="text-xs font-black tracking-[0.2em] text-[#39B54A] mb-4 uppercase">Diferenciais</h2>
              </Reveal>
              <Reveal delay={100}>
                <h3 className="text-4xl md:text-5xl font-black mb-6 text-gray-900 leading-tight">Por que escolher a Energy Solaris?</h3>
              </Reveal>
              <Reveal delay={200}>
                <p className="text-gray-600 text-lg font-medium leading-relaxed">
                  Combinamos rigor técnico com uma visão estratégica de negócio, entregando mais do que energia: entregamos liberdade financeira e segurança operacional.
                </p>
              </Reveal>
            </div>

            <div className="grid sm:grid-cols-2 gap-8">
              {differentials.map((diff, idx) => (
                <Reveal key={idx} delay={300 + (idx * 100)}>
                  <div className="space-y-2 border-l-2 border-[#39B54A] pl-6 h-full flex flex-col justify-center">
                    <h4 className="text-xl font-black text-gray-900">{diff.title}</h4>
                    <p className="text-gray-500 text-sm font-medium leading-relaxed">{diff.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={700}>
              <div className="pt-4">
                <AnimatedButton 
                  text="Garantir minha economia" 
                  href={waLink} 
                  className="!px-12"
                />
              </div>
            </Reveal>
          </div>

          <div className="relative">
            <Reveal threshold={0.3}>
              <div className="absolute -inset-4 bg-[#39B54A]/5 rounded-[40px] blur-2xl"></div>
              <div className="relative bg-white border border-gray-100 rounded-[40px] p-8 md:p-12 overflow-hidden group shadow-xl">
                <div className="absolute top-0 right-0 p-8">
                  <svg className="w-16 h-16 text-[#39B54A]/10" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M4.5 3h15a1.5 1.5 0 011.5 1.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3z" />
                  </svg>
                </div>
                <h4 className="text-3xl font-black mb-8 relative z-10 text-gray-900 leading-tight">Solicite sua proposta técnica agora</h4>
                <p className="text-gray-600 mb-8 relative z-10 font-medium leading-relaxed">Nossa equipe de engenharia realizará um estudo personalizado para seu perfil de consumo sem custo algum.</p>
                
                <AnimatedButton 
                  text="Receber proposta rápida" 
                  href={waLink} 
                  className="w-full !rounded-2xl"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentials;